/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import { Layout } from '../../../shared/layout/layout';
import { Container } from './candidate-response-interview-style';
import QuestionnaireInterview from '../../../shared/components/questionnaire-interview-common/questionnaire-interview-common';
// import QuestionnaireInterview from '../../../shared/components/questionnaire-interview-common/questionnaire-interview-common';
// import QuestionnaireInterviewStartup from '../../../shared/components/questionnaire-interview-startup/questionnaire-interview-startup';


const CandidateResponseInterview = () => {

  return (
    <Layout>
      <Container>
        {/* <QuestionnaireInterviewStartup />*/}
        <QuestionnaireInterview />

        {/* <Chat /> */}
      </Container>
    </Layout>
  );
};

export default CandidateResponseInterview;
